import { render, staticRenderFns } from "./fileStatistics.vue?vue&type=template&id=64aff6ce&scoped=true"
import script from "./fileStatistics.vue?vue&type=script&lang=js"
export * from "./fileStatistics.vue?vue&type=script&lang=js"
import style0 from "./fileStatistics.vue?vue&type=style&index=0&id=64aff6ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aff6ce",
  null
  
)

export default component.exports